export default {
  pdType: 'one',
  far: {
    left: { pd: '' },
    right: { pd: '' }
  },
  close: {
    left: { pd: '' },
    right: { pd: '' }
  },
  addition: 0,
  currentStep: 1,
  steps: [],
  selections: {},
  stepData: {},
  quantity: 1,
  rowId: null,
  prescriptionData: {},
  prescriptionDataSubmitted: false,
  initialData: null,
  isAdvancing: false,
  isGoingBack: false,
  prices: {},
  priceMapping: {
    'lens_quality': 'price_1',
    'thinning': 'price_2',
    'filter': 'price_3',
    'lens_pattern': 'price_4',
  },
  csv: [],
  productData: {}
}
